import { api } from '.';
import { query_params } from '../helpers/api';

export const listResponsesForSurvey = (surveyId: string) =>
  api.get(`/spec/responses?survey=${surveyId}`).then(result => result.data)
